const Message = ({msg,type}) => {

  return (
    <>
    {type==="success" && (
      <div id="message-ss" className="mt-1 mb-2 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative" role="alert">
        <strong className="font-bold">Yahooooo! </strong>
        <span className="block sm:inline">Tudo certo até aqui!</span>
      </div>
    )}
    {type==="error" && (
      <div className="mt-1 mb-2 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
        <strong className="font-bold">Oops... Algo deu errado! </strong>
        <span className="block sm:inline">{msg}</span>
      </div>
    )}
    </>
  );
};

export default Message;